var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4395 17.0389C16.0597 15.9757 15.2227 15.0363 14.0584 14.3662C12.8941 13.6962 11.4676 13.333 10 13.333C8.53243 13.333 7.10588 13.6962 5.94159 14.3662C4.77729 15.0363 3.94032 15.9757 3.56049 17.0389",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 6.66634,
    rx: 3.33333,
    ry: 3.33333,
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e1a353c89743d56e5e5f89e2c8b8b4f7.svg";
export { ForwardRef as ReactComponent };